<script setup lang="ts">
/***
 * template to show array of enums
 */
import type { DataTableCellProps } from './templateTypes';
const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <div v-for="(arrayValue, arrayIndex) in cell.value" :key="arrayIndex">
    <pre>{{ arrayValue }}</pre>
  </div>
</template>
